module.exports = __webpack_public_path__ + "img/yiliao2.81457387.png";